<div class="d-flex ">
    <div class="score made m-auto">
        <div role="progressbar" attr.aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="100"
            style="--value: {{value}}"></div>
    </div>
</div>
